module.exports = __webpack_public_path__ + "a8c71ab07e128d9509fd7c6739ceeffd.jpg";